"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFolderConversationMemberKind = void 0;
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const FolderMessage_1 = __importDefault(require("./FolderMessage"));
var EFolderConversationMemberKind;
(function (EFolderConversationMemberKind) {
    EFolderConversationMemberKind["CUSTOMER"] = "CUSTOMER";
    EFolderConversationMemberKind["THIRD_PARTY"] = "THIRD_PARTY";
    EFolderConversationMemberKind["INVITED_NOTARY"] = "INVITED_NOTARY";
})(EFolderConversationMemberKind || (exports.EFolderConversationMemberKind = EFolderConversationMemberKind = {}));
class FolderConversation extends Resource_1.default {
}
exports.default = FolderConversation;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderConversation.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", OfficeFolder_1.default)
], FolderConversation.prototype, "folder", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderConversation.prototype, "folder_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EFolderConversationMemberKind),
    __metadata("design:type", String)
], FolderConversation.prototype, "member_kind", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderConversation.prototype, "customer_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderConversation.prototype, "third_party_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderConversation.prototype, "folder_sharing_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, classTransformer_1.Type)(() => FolderMessage_1.default),
    __metadata("design:type", Array)
], FolderConversation.prototype, "messages", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderConversation.prototype, "member_display_name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderConversation.prototype, "member_email", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], FolderConversation.prototype, "unread_count", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], FolderConversation.prototype, "last_message_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], FolderConversation.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], FolderConversation.prototype, "updated_at", void 0);
